<template>
	<page>
		<title-view>
			מסך users
			<v-btn
				slot="actions"
				btn
				@click="onEdit({})"
			>
				add User
			</v-btn>
		</title-view>
		<row>
			<c-col>
				<users-table @edit="onEdit" />
			</c-col>
		</row>
		<popup-dialog v-model="openModal">
			<span slot="header">יצירת/עריכת User</span>
			<user-form @save="openModal=false" />
		</popup-dialog>
	</page>
</template>

<script>
import UserForm from "src/views/users/UserForm";
import UsersTable from "src/views/users/UsersTable";
import UserModule from "src/store/modules/User.module";
export default {
	name: "UsersView",
	components: { UsersTable, UserForm },
	data () {
		return {
			openModal: false,
		};
	},
	methods: {
		onEdit (user) {
			this.$store.commit(UserModule.types.GET, user);
			this.openModal = true;
		},
	},

};
</script>

<style scoped>

</style>
